import React, { useState } from 'react';
import { fetchAddressExceptions } from '../services/api';
import { CustomerPicker, EditDialog, Field, ListCard, PageTitle, WriteOffNote, useRows, useSave, useWriteLive } from '../components/StaffList';

/**
 * Tools & Lists > Shipping Address Exceptions: customers whose addresses skip validation (Azure exit
 * WS8). Reads sql01.ShippingAddressExceptions. Saving is off until ws8_address_exceptions_live.
 */

const showDate = (ymd) => { const [y, m, d] = ymd.split('-'); return `${m}/${d}/${y}`; };

export default function AddressExceptions() {
  const live = useWriteLive('ws8_address_exceptions');
  const [customerName, setCustomerName] = useState('');
  const [email, setEmail] = useState('');
  const [edit, setEdit] = useState(null);
  const { rows, error, reload } = useRows(() => fetchAddressExceptions({ customerName, email }), [customerName, email]);
  const { save, saving, error: saveError, setError } = useSave(reload);

  const open = (r) => { setError(null); setEdit(r ? { ...r, note: r.note || '' } : { id: 0, note: '' }); };
  const submit = async () => {
    if (!edit.contactId) return setError('Please select a customer.');
    if (await save('address_exception_save', { id: edit.id, contactId: edit.contactId, note: edit.note })) setEdit(null);
    return null;
  };
  const remove = (r) => {
    // eslint-disable-next-line no-alert
    if (window.confirm('Do you want to delete?')) save('address_exception_delete', { id: r.id });
  };

  return (
    <div>
      <PageTitle>Shipping Address Exceptions</PageTitle>
      <WriteOffNote live={live} />
      <div className="port-filters">
        <input className="form-input" style={{ width: 'auto' }} placeholder="Customer name" aria-label="Customer name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
        <input className="form-input" style={{ width: 'auto' }} placeholder="Email" aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button type="button" className="btn btn-primary" disabled={!live} onClick={() => open(null)}>Add Exception</button>
      </div>
      <ListCard title="Exceptions" rows={rows} error={error} empty="No exceptions.">
        <table className="trans-table">
          <thead><tr><th>Customer</th><th>Note</th><th>Added</th><th aria-label="Actions" /></tr></thead>
          <tbody>
            {(rows || []).map((r) => (
              <tr key={r.id}>
                <td>{r.firstName} {r.lastName}<br />{r.email}</td>
                <td>{r.note}</td>
                <td>{showDate(r.createdAt)}</td>
                <td className="staff-actions">
                  <button type="button" className="btn btn-ghost" disabled={!live || saving} onClick={() => open(r)}>Edit</button>
                  <button type="button" className="btn btn-ghost" disabled={!live || saving} onClick={() => remove(r)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </ListCard>
      {!edit && saveError && <div className="staff-msg staff-msg-error">{saveError}</div>}
      {edit && (
        <EditDialog title={edit.id ? 'Edit Exception' : 'Add Exception'} live={live} saving={saving} error={saveError} onClose={() => setEdit(null)} onSave={submit}>
          {edit.contactId
            ? <div className="staff-store"><strong>{edit.firstName} {edit.lastName}</strong><br />{edit.email}</div>
            : <CustomerPicker onPick={(c) => setEdit({ ...edit, ...c })} />}
          {edit.contactId && <Field label="Note"><input className="form-input" maxLength={255} value={edit.note} onChange={(e) => setEdit({ ...edit, note: e.target.value })} /></Field>}
        </EditDialog>
      )}
    </div>
  );
}
